var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneDrive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4485_36412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3545 23.9626L25.355 23.9607L37.1109 31.0023L44.116 28.0544C45.5395 27.439 47.0744 27.1235 48.6252 27.125C48.8835 27.125 49.1389 27.1367 49.393 27.1537C48.5508 23.8697 46.7729 20.901 44.2753 18.6083C41.7777 16.3157 38.668 14.7978 35.324 14.2392C31.9801 13.6806 28.5458 14.1053 25.4387 15.4616C22.3315 16.8179 19.6852 19.0476 17.8213 21.8795C17.8812 21.8788 17.9401 21.875 18.0002 21.875C20.5983 21.8715 23.1457 22.5946 25.3545 23.9626Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3548 23.9607L25.3543 23.9626C23.1455 22.5946 20.5981 21.8715 18 21.875C17.94 21.875 17.8809 21.8788 17.8211 21.8795C15.2782 21.911 12.7919 22.6348 10.6295 23.9732C8.467 25.3116 6.71014 27.2139 5.54765 29.4758C4.38516 31.7377 3.861 34.2736 4.03149 36.811C4.20198 39.3484 5.06068 41.7913 6.51531 43.8774L16.8823 39.5147L21.4908 37.5754L31.752 33.2574L37.1107 31.0023L25.3548 23.9607Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3925 27.1537C49.1384 27.1367 48.883 27.125 48.6246 27.125C47.0738 27.1235 45.5392 27.4402 44.1158 28.0556L37.1104 31.0023L39.1417 32.2191L45.8003 36.2075L48.7055 37.9477L58.6391 43.8978C59.5417 42.2222 60.0094 40.3469 59.9995 38.4437C59.9895 36.5405 59.5022 34.6701 58.5822 33.0041C57.6621 31.338 56.3387 29.9294 54.7332 28.9073C53.1277 27.8852 51.2914 27.2822 49.3925 27.1537Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7061 37.9473L45.801 36.2071L39.1424 32.2187L37.111 31.002L31.7523 33.257L21.4911 37.575L16.8826 39.5144L6.51562 43.877C7.80391 45.7292 9.52134 47.2421 11.5212 48.2865C13.5211 49.3309 15.7441 49.8758 18.0003 49.8746H48.6253C50.6787 49.8752 52.6939 49.3199 54.4571 48.2675C56.2203 47.2151 57.6656 45.705 58.6397 43.8974L48.7061 37.9473Z",
    fill: "#28A8EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4485_36412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 35.875,
    fill: "white",
    transform: "translate(4 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneDrive);
export default __webpack_public_path__ + "static/media/oneDrive.8c9cae1c97050ad8cf4f8bdc79406fdf.svg";
export { ForwardRef as ReactComponent };